






































































































import Vue from 'vue'
import axios from 'axios';
// import * as sentry from '@sentry/browser';
import { parse } from 'date-fns';

export default Vue.extend({
    props: [
      'users',
      'items',
      'show',
      'clientId',
      'projects'
    ],
    data() {
      return {
        bulkActions: {} as any,
        isBilledAtModalOpen: false
      }
    },
    mounted() {
      this.bulkActions.ids = this.items.map((x: any) => x.id);
      this.bulkActions.client_id = this.clientId;
    },
    methods: {
      updateBilledDate() {
//
      },
      updateProject(data: any) {
        debugger;
          this.bulkActions.project = this.projects.find((x: any) => x.id === data)?.name;
      },
      displayProjectItem(item: any) {
          return item.name;
      },
      async sendBulkActions() {
        try {
          this.bulkActions.billed_at = parse(`${this.bulkActions.billed_date}`);
          
          const result = await axios.post(`/time-entries/bulk`, this.bulkActions);
          this.emit('updated', result.data);
        } catch (e) {
          console.error(e);
          // sentry.captureException(e);
        }
      },
      emit(action: string, data: any) {
        this.$emit(action, data);
      }
    }
});
